import Vue from "vue";
import Vuex from "vuex";
import { messageApi } from "@/api/message.js";
import {
  localDevelopmentMenu,
  localDevelopmentPermissions,
} from "@/mock/localMenu";
import { isDemoMode } from "@/utils/demoMode";
Vue.use(Vuex);

const storedMenu = JSON.parse(sessionStorage.getItem("menu_list")) || [];
const initialMenu = isDemoMode ? localDevelopmentMenu : storedMenu;

if (isDemoMode) {
  sessionStorage.setItem("menu_list", JSON.stringify(localDevelopmentMenu));
  sessionStorage.setItem(
    "roleInfo",
    JSON.stringify(localDevelopmentPermissions)
  );
}

export default new Vuex.Store({
  state: {
    hideList: "",
    selectIndex: "",
    threeChildren: "",
    updateViewNotice: "",
    requestParam: {
      pageNum: 1,
      pageSize: 5,
      messageFlag: 2,
    },
    total: 0,
    componentStatus: sessionStorage.getItem("componentStatus") || 0,
    messageData: [],
    menuList: initialMenu,
    userInfo: JSON.parse(sessionStorage.getItem("user_info")) || {},
    authority:[],
    control:{},//安全管理按钮
  },
  mutations: {
    increment(state, el) {
      state.hideList = el;
    },
    selectChild(state, el) {
      state.selectIndex = el;
    },
    selectChildren(state, el) {
      state.threeChildren = el;
    },
    updateView(state, el) {
      state.updateViewNotice = el;
    },
    updateStatus(state, el) {
      state.componentStatus = el;
      // Vue.set(state, "componentStatus", el);
    },

    updateMenuList(state, el) {
      state.menuList = el;
    },
    updateUserInfo(state, el) {
      state.userInfo = el;
    },
    updateMessage(state, el) {
      if (el.length !== 0) {
        state.total = el[0].count;
      }else{
        state.total = 0;
      }
      state.messageData = el;
    },
    authorityList(state, el) {
      state.authority = el;
    },
    getControl(state, el) {
      state.control = el;
    },
  },
  actions: {
    queryMessage(context) {
      if (isDemoMode) {
        context.commit("updateMessage", []);
        return;
      }
      messageApi.queryMessage(context.state.requestParam).then((res) => {
        if (res && res.code === 200) {
          context.commit("updateMessage", res.data);
        }
      }).catch(() => {});
    },
  },
  modules: {},
});
